var map = {
	"./aave-market-data.json": 46886,
	"./balancer-market-data.json": 31492,
	"./compound-market-data.json": 12496,
	"./curve-market-data.json": 13177,
	"./dodo-market-data.json": 65795,
	"./frax-market-data.json": 21957,
	"./instadapp-market-data.json": 19229,
	"./lido-market-data.json": 58631,
	"./yearn-market-data.json": 12201
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46211;